import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DropdownOptions from "../../../../../constants/DropdownOptions";
import { deleteFieldGroupAction, fieldGroupListAction, grpEditAction } from "../../../../../modules/fieldgroups/action";
import AllMainFarmSelectedDialog from "../../../../Common/AllMainFarmSelectedDialog";
import { isSuperAdmin } from "../../../../Common/CheckAuthorization";
import TabHeaderAndButton from "../../../../Common/TabHeaderAndButton";
import CreateTable from "../../../../CreateTable";
import ConfirmationDialog from "../../../../FormElement/ConfirmationDialog";
import Loader from "../../../../Loader";


class FieldGroupView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      headerRows: {
        updatedAt: "Last Updated",
        updatedBy: "Updated By",
        name: "Name",
        fields: "Fields Count",
        indicators: "Load Number Count"
      },
      order: "desc",
      orderBy: "id",
      open: false
    };
  }

  componentDidMount() {
    const { fieldGroupListAction, selectedYear } = this.props;
    if(!isSuperAdmin() || this.props.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id) {
    fieldGroupListAction(selectedYear);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.rowFieldGroup &&
      this.props.rowFieldGroup !== nextProps.rowFieldGroup &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
    if (this.props.MainFarmId !== nextProps.MainFarmId &&
      nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id) {
        this.props.fieldGroupListAction(this.props.selectedYear);
      }
    if (nextProps.selectedYear && nextProps.selectedYear !== this.props.selectedYear &&
      (!isSuperAdmin() || nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id)) {
      this.props.fieldGroupListAction(nextProps.selectedYear);
    }
  }

  deleteRow = id => {
    this.setState({
      open: true,
      id: id
    });
  };

  handleClose = () => {
    this.setState({
      open: false
    });
  };

  handleOk = () => {
    const { id } = this.state;
    this.handleClose();
    this.props.deleteFieldGroupAction(id);
  };

  editRow = id => {
    localStorage.setItem("currentFieldGrpId", id);
    const { rowFieldGroup } = this.props;
    const requiredData = rowFieldGroup.find(group => group.id === id);
    this.props.grpEditAction(requiredData);
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };

  render() {
    const { rowFieldGroup } = this.props;
    const { fetchingComplete, order, orderBy, open } = this.state;
    const prevPath = "farmsetup/farminformation",
      currentPage = "/field-groups";
    return (
      <div className="ticket-body">
        <ConfirmationDialog
          open={open}
          handleClose={this.handleClose}
          handleOk={this.handleOk}
        />
        <TabHeaderAndButton
          header="Field Groups"
          path={`/${prevPath}${currentPage}/create`}
          isDisabled={isSuperAdmin() && this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id}
          btnLabel="New group"
        />
        {isSuperAdmin() && this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id ? (
          <AllMainFarmSelectedDialog/>
        ) : (
            <div>
              {fetchingComplete ? (
                <CreateTable
                  order={order}
                  orderBy={orderBy}
                  headerRows={this.state.headerRows}
                  rowData={rowFieldGroup}
                  delete={this.deleteRow}
                  location={`${prevPath}${currentPage}/edit`}
                  edit={this.editRow}
                  onRequestSort={this.handleRequestSort}
                  loc={`/${prevPath}${currentPage}`}
                />
              ) : (
                <Loader />
              )}
            </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    rowFieldGroup: state.fieldGroupReducer.fieldGroupList,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    selectedYear: state.harvestYearReducer.selectedYear
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { fieldGroupListAction, deleteFieldGroupAction, grpEditAction },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FieldGroupView);



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/FieldGroups/FieldGroupView.js